import { Component, OnInit, ViewChild } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { SessionStorageService } from 'ngx-webstorage';
import { AtlasInputPhoneComponent } from '@ui/components/atlas-inputphone/atlas-inputphone.component';
import { AtlasGridComponent } from '@ui/components/atlas-grid/atlas-grid.component';
import { Profile } from '@models/profile';
import { ROLE_OWNER_ID } from '@models/role';
import { User } from '@models/user';
import { NgbModalRef, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { AtlasToastService } from '@services/atlas-toast.service';
import { ProfileService } from '@services/profile.service';
import { UserService } from '@services/user.service';
import { AtlasGridOptions } from '@ui/components/atlas-grid/altas-grid-options.model';
import { ButtonGroupRendererComponent } from '@ui/components/atlas-grid/renderer/buttongroup-renderer.component';
import { AtlasGridTranslateRendererComponent } from '@ui/components/atlas-grid/renderer/translate-renderer.component';
import { validateFormGroup } from '@utils/utils';
import { LoaderService } from '@services/loader.service';
import { finalize } from 'rxjs/operators';
import { AtlasGridHtmlRendererComponent } from '@ui/components/atlas-grid/renderer/html-renderer.component';
import { TranslateService } from '@ngx-translate/core';
import { DomainService } from '@services/domain.service';
import { Domain } from '@models/domain';
import { LoginService } from 'src/app/core/login/login.service';

// import {faEdit, faEye, faTrash} from '@fortawesome/free-solid-svg-icons';
@Component({
  selector: 'wsb-profile-manage',
  templateUrl: './profile-manage.component.html',
  styleUrls: ['./profile-manage.component.scss'],
  standalone: false
})
export class ProfileManageComponent implements OnInit {
  @ViewChild('modalEdit') modalEdit;
  @ViewChild('modalDelete') modalDelete;
  @ViewChild('inputPhone') inputPhone: AtlasInputPhoneComponent;
  @ViewChild(AtlasGridComponent) grid: AtlasGridComponent;
  modalEditModal: NgbModalRef;
  modalDeleteModal: NgbModalRef;
  editForm: UntypedFormGroup = null;
  user: User | null;
  elementToEdit: Profile | null;
  elementToDelete: Profile | null;
  // profilesCache: Profiles;

  tableColumnDefs = null;
  tableGridOptions = null;
  tableData = null;
  components = {
    buttonGroupRenderer: ButtonGroupRendererComponent,
    translateRenderer: AtlasGridTranslateRendererComponent,
    htmlRenderer: AtlasGridHtmlRendererComponent
  };
  tableLoading: boolean;
  paginationPageSize = 10;
  roles: Array<object>;
  domain: Domain;

  constructor(
    private userService: UserService,
    private profileService: ProfileService,
    private modalService: NgbModal,
    private loaderService: LoaderService,
    private formBuilder: UntypedFormBuilder,
    private atlasToast: AtlasToastService,
    private sessionStorage: SessionStorageService,
    private translateService: TranslateService,
    private domainService: DomainService,
    private loginService: LoginService
  ) {}

  ngOnInit() {
    this.domainService.getDomainState().subscribe(x => {
      this.domain = x;
    });
    this.editForm = this.formBuilder.group({
      userName: [''],
      name: ['', [Validators.required, Validators.minLength(2), Validators.maxLength(49)]],
      surname: ['', [Validators.required, Validators.minLength(2), Validators.maxLength(49)]],
      email: ['', [Validators.required, Validators.email]],
      phone: ['', Validators.pattern(/^(\+)?[0-9]{5,15}$/)],
      role: ['', [Validators.required]]
    });
    this.userService.getAuthenticationState().subscribe(next => (this.user = next));

    this.editForm.get('email').valueChanges.subscribe(value => {
      this.editForm.get('userName').setValue(value);
    });

    const thisProfile = this.sessionStorage.retrieve('wsb-userprofile-key');

    this.tableColumnDefs = [
      // {
      //   headerNameTranslate: 'user_username_table',
      //   field: 'userName'
      // },
      {
        headerNameTranslate: 'common_email',
        field: 'email'
      },
      {
        headerNameTranslate: 'user_name',
        field: 'name'
      },
      {
        headerNameTranslate: 'user_surname',
        field: 'surname'
      },
      {
        headerNameTranslate: 'user_status',
        field: 'status',
        // width: 125,
        cellRenderer: 'htmlRenderer',
        cellRendererParams: {
          content: params => {
            if (params.data.status) {
              switch (params.data.status) {
                case 'OK':
                  return '<span class="badge badge-ok">' + params.data.status + '</span>';
                  break;
                default:
                  return '<span class="badge badge-pending">' + params.data.status + '</span>';
                  break;
              }
            }
            return '';
          }
        }
      },
      {
        headerNameTranslate: 'user_role',
        cellRenderer: 'translateRenderer',
        cellRendererParams: {
          content: params => {
            if (params && params.node.data) {
              return this.translateService.instant('USER_' + params.node.data.role.id);
            } else {
              return '';
            }
          }
        },
        valueGetter: params => {
          return params.node.data.role.id;
        }
      },
      {
        // headerNameTranslate: 'common_actions',
        cellRenderer: 'buttonGroupRenderer',
        sortable: false,
        cellRendererParams: {
          hide: data => {
            if (!data) {
              return true;
            } else {
              return data.idUserProfile === thisProfile || data.role.id === ROLE_OWNER_ID;
            }
          },
          items: [
            {
              onClick: e => this.openModalEdit(e),
              label: 'common_edit'
              // variant: 'primary',
            },
            {
              onClick: e => this.openModalDelete(e),
              label: 'common_delete'
              // variant: 'danger',
            }
            // {
            //   onClick: e => this.view(e),
            //   label: 'groups_table_action_view'
            //   // variant: 'primary',
            // }
          ]
        },
        cellClass: ['button-group', 'text-end'],
        maxWidth: 82
      }
    ];
    // const that = this;
    this.tableGridOptions = AtlasGridOptions.deserialize({
      pagination: true,
      paginationPageSize: this.paginationPageSize
      // loadFunction: this.reloadList.bind(that)
    });

    this.profileService.getRoles().subscribe(x => (this.roles = x));
    this.reloadList();
  }

  // reloadList(startRow?, endRow?) {
  //   return new Observable(observer => {
  //     if (!this.profilesCache) {
  //       // const thisProfile = this.sessionStorage.retrieve('wsb-userprofile-key');
  //       this.profileService.getProfiles(1, 10000).subscribe(x => {
  //         // const filtered = x.data.filter(y => y.idUserProfile !== thisProfile && y.role.id !== ROLE_OWNER_ID);
  //         // this.profilesCache = Profiles.deserialize({ data: filtered, total: filtered.length });
  //         this.profilesCache = x;
  //         observer.next(this.profilesCache);
  //         observer.complete();
  //       });
  //     } else {
  //       observer.next(this.profilesCache);
  //       observer.complete();
  //     }
  //   });
  //   // return this.profileService.getProfiles(1 + startRow / this.paginationPageSize, this.paginationPageSize);
  // }

  reloadList(startRow?, endRow?) {
    this.loaderService.show();
    this.profileService
      .getProfiles(1, 10000)
      .pipe(finalize(() => this.loaderService.hide()))
      .subscribe(data => {
        this.tableData = data.toRawValue() as any;
        this.tableLoading = false;
      });
  }

  openModalEdit(data?: any): void {
    this.editForm.reset();
    this.elementToEdit = data;
    this.modalEditModal = this.modalService.open(this.modalEdit);
    if (data) {
      this.editForm.patchValue(data);
      this.editForm.get('role').setValue(data.role.id);
    }
    this.modalEditModal.result.then(
      result => {},
      reason => {}
    );
  }

  openModalDelete(data: any): void {
    this.elementToDelete = data;
    this.modalDeleteModal = this.modalService.open(this.modalDelete);
    this.modalDeleteModal.result.then(
      result => {},
      reason => {}
    );
  }

  modalEditForm(): void {
    if (!this.editForm.valid) {
      validateFormGroup(this.editForm);
      return;
    }
    this.editForm.disable();

    const raw = Profile.deserialize(this.editForm.getRawValue());
    raw.role = { id: raw.role };
    if (this.elementToEdit) {
      raw.idUserProfile = this.elementToEdit.idUserProfile;
      raw.status = this.elementToEdit.status;
      raw.role.operations = this.elementToEdit.role.operations;
    } else {
      raw.idUser = this.sessionStorage.retrieve('wsb-user-key');
    }

    const onSuccess = () => {
      this.editForm.reset();
      this.editForm.enable();
      this.reloadList();
      this.modalEditModal.close();
      this.atlasToast.success('common_success', null);
    };

    const onError = (error, wsbError = true) => {
      let messageLabel = null;
      if (error.error && wsbError) {
        if (typeof error.error === 'string') {
          const errorDetails = JSON.parse(error.error);
          if (errorDetails && errorDetails.error_message) {
            messageLabel = errorDetails.error_message;
          }
        }
      }
      this.atlasToast.error('common_error', messageLabel);
      this.editForm.enable();
      this.reloadList();
    };

    if (this.elementToEdit) {
      this.profileService.updateProfile(this.elementToEdit, raw).subscribe(
        () => {
          onSuccess();
        },
        e => {
          onError(e);
        }
      );
    } else {
      this.profileService.addProfile(Profile.deserialize(raw)).subscribe(
        () => {
          if (this.loginService.isUniversalLogin()) {
            this.profileService.askAuth0ResetPassword(this.domain, raw.email).subscribe(
              () => {
                onSuccess();
              },
              e => {
                onError(e, false);
              }
            );
          } else {
            onSuccess();
          }
        },
        e => {
          onError(e);
        }
      );
    }
  }

  modalDeleteForm(): void {
    // const that = this;
    this.profileService.removeProfile(this.elementToDelete).subscribe(
      () => {
        this.atlasToast.success('common_success', null);
        this.reloadList();
      },
      () => {
        this.atlasToast.error('common_error', null);
      },
      () => {}
    );
    this.modalDeleteModal.close();
  }
}
